var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmqxDisconnectedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00146 4.51599C2.00049 4.54379 2 4.5718 2 4.6V9.4C2 10.3 2.5 11 3.2 11H8.48547L6.48547 9H4V6.51453L2.00146 4.51599ZM10 6.86926L9.13074 6H10V6.86926ZM12.1307 9H20V5H8.13074L6.13074 3H20.8C21.5 3 22 3.7 22.1 4.6V9.4C22.1 10.3 21.5 11 20.9 11H14.1307L12.1307 9ZM10.4855 13H3.2C2.5 13 2 13.7 2 14.6V19.4C2 20.3 2.5 21 3.2 21H18.4855L16.4855 19H4V15H12.4855L10.4855 13ZM18.1307 15L16.1307 13H20.9C21.6 13 22.1 13.7 22.1 14.6V18.9693L20 16.8693V15H18.1307ZM5 7.51453V8H5.48547L5 7.51453ZM10 16V18H9V16H10ZM7 18H5V16H7V18Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 3,
    width: 2,
    height: 27,
    rx: 1,
    transform: "rotate(-45 2 3)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmqxDisconnectedIcon);
export default __webpack_public_path__ + "static/media/emqx-disconnected-icon.f4a5781c4edef1fb6ebcff4e96d67a07.svg";
export { ForwardRef as ReactComponent };